import { RootState } from "store/store";

export const selectToken = (state: RootState) => state.appState.token;

export const selectIsAppLoading = (state: RootState) => state.appState.loadingRequests.length > 0;